// Shared vocabulary of the billing screens: the ledger and the detail
// pages must call the same status by the same word and color.

export const PAYMENT_LABEL: Record<string, string> = {
  pending: "Processing",
  succeeded: "Paid",
  expired: "Expired - not charged",
  refunded: "Refunded",
  failed: "Failed",
};

// A charge that failed is an error and a reversal reopened a bill; only an
// abandoned checkout is neutral history.
export const PAYMENT_PILL: Record<string, string> = {
  pending: "warn",
  succeeded: "ok",
  expired: "muted",
  refunded: "warn",
  failed: "crit",
};

export const METHOD_LABEL: Record<string, string> = {
  cash: "Cash",
  check: "Check",
  zelle: "Zelle",
  other: "Other",
};

export const INVOICE_PILL: Record<string, string> = {
  open: "warn",
  paid: "ok",
  void: "muted",
};

export function day(iso: string | null | undefined): string {
  return iso ? String(iso).slice(0, 10) : "";
}

// The matter card and the client tab carry no band: an empty one says this
// where it would otherwise invite a bill.
export const BILLING_OFF_COPY = "Billing is switched off: nothing can be billed until it is on.";
